import { call, takeLatest } from 'redux-saga/effects';

import * as constants from './meeting-templates.constants';
import * as services from './meeting-templates.saga-services';

function* invokeFetchMeetingTemplates() {
  yield call(services.fetchMeetingTemplates);
}

export function* watchMeetingTemplatesPageSaga() {
  yield takeLatest(constants.FETCH_MEETING_TEMPLATES, invokeFetchMeetingTemplates);
}
